const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
  // Sticky cart synchronization events
  stickyQuantitySync: "sticky-quantity-sync",
  stickyVariantSync: "sticky-variant-sync",
};
